"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPayhawkCustomerVaultId = exports.getCreditCardInfo = exports.getPayhawkItem = exports.getPayhawkBilling = exports.ePayhawkRequestType = void 0;
const utils_1 = require("@loadsure/utils");
var ePayhawkRequestType;
(function (ePayhawkRequestType) {
    ePayhawkRequestType["SALE"] = "sale";
    ePayhawkRequestType["REFUND"] = "refund";
    ePayhawkRequestType["VOID"] = "void";
})(ePayhawkRequestType = exports.ePayhawkRequestType || (exports.ePayhawkRequestType = {}));
function getPayhawkBilling(insurancePurchase) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const [firstName, lastName] = utils_1.splitFullName(insurancePurchase.assured.name);
    return {
        first_name: firstName !== null && firstName !== void 0 ? firstName : "",
        last_name: lastName !== null && lastName !== void 0 ? lastName : "",
        email: insurancePurchase.assured.email,
        city: (_b = (_a = insurancePurchase.assured.address) === null || _a === void 0 ? void 0 : _a.city) !== null && _b !== void 0 ? _b : "",
        state: (_d = (_c = insurancePurchase.assured.address) === null || _c === void 0 ? void 0 : _c.state) !== null && _d !== void 0 ? _d : "",
        country: (_f = (_e = insurancePurchase.assured.address) === null || _e === void 0 ? void 0 : _e.country) !== null && _f !== void 0 ? _f : "",
        zip: (_h = (_g = insurancePurchase.assured.address) === null || _g === void 0 ? void 0 : _g.postal) !== null && _h !== void 0 ? _h : "",
        phone: (_j = insurancePurchase.assured.phone) !== null && _j !== void 0 ? _j : "",
        address1: (_l = (_k = insurancePurchase.assured.address) === null || _k === void 0 ? void 0 : _k.address1) !== null && _l !== void 0 ? _l : "",
        address2: (_o = (_m = insurancePurchase.assured.address) === null || _m === void 0 ? void 0 : _m.address2) !== null && _o !== void 0 ? _o : ""
    };
}
exports.getPayhawkBilling = getPayhawkBilling;
function getPayhawkItem(insurancePurchase, partnerId, certificateNumber, portalName) {
    var _a, _b, _c, _d, _e, _f;
    return {
        item_product_code_1: insurancePurchase.coverage.id,
        item_description_1: insurancePurchase.coverage.name,
        item_unit_cost_1: (_b = (_a = insurancePurchase.coverage.costsUSD) === null || _a === void 0 ? void 0 : _a.premium) !== null && _b !== void 0 ? _b : insurancePurchase.coverage.premium,
        item_total_amount_1: insurancePurchase.coverage.totalAmountInUSD,
        merchant_defined_field_1: `Portal: ${portalName}`,
        merchant_defined_field_2: `Partner Id: ${partnerId}`,
        orderid: certificateNumber,
        item_quantity_1: "1",
        surcharge: (_d = (_c = insurancePurchase.coverage.costsUSD) === null || _c === void 0 ? void 0 : _c.serviceFee) !== null && _d !== void 0 ? _d : insurancePurchase.coverage.serviceFee,
        tax: (_f = (_e = insurancePurchase.coverage.costsUSD) === null || _e === void 0 ? void 0 : _e.tax) !== null && _f !== void 0 ? _f : insurancePurchase.coverage.tax
    };
}
exports.getPayhawkItem = getPayhawkItem;
function getCreditCardInfo(payhawkResponse) {
    const { nm_response: { customer_vault: { customer: { cc_number: { _text: maskedCardNumber }, first_name: { _text: firstName }, last_name: { _text: lastName }, address_1: { _text: billingAddress }, cc_exp: { _text: expirationDate } } } } } = payhawkResponse;
    const cardHolderName = utils_1.fullName(firstName, lastName);
    return {
        maskedCardNumber,
        cardHolderName,
        billingAddress,
        expirationDate
    };
}
exports.getCreditCardInfo = getCreditCardInfo;
function getPayhawkCustomerVaultId(payhawkResponse) {
    const { customer_vault_id: customerVaultId } = payhawkResponse;
    return customerVaultId;
}
exports.getPayhawkCustomerVaultId = getPayhawkCustomerVaultId;
//# sourceMappingURL=index.js.map